import api from "../config/api";
import { toFormData } from "../config/functions";
import { Employee } from "../types/Employee";

const API_URL = "/employee";

// Get all employees
export const getEmployees = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

// Get employee by ID using query parameter
export const getEmployeeById = (employeeId: string) =>
  api.get(`${API_URL}/?id=${employeeId}`);

// Create a new employee (typically uses POST)
export const createEmployee = (data: Employee) => {
  const formData = toFormData(data);
  return api.post(`${API_URL}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Update an employee using query parameter
// export const updateEmployee = (id: number, data: Employee) =>
//   api.put(`${API_URL}/?id=${id}`, data, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });

export const updateEmployee = (id: number, data: Employee) => {
  console.log("Update Employee Data", data);

  const formData = toFormData(data);

  return api.post(`${API_URL}/?id=${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Delete an employee using query parameter
export const deleteEmployee = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
